module.exports = __webpack_public_path__ + "img/categories-1.8331d394.jpg";